import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Formato, TipologiaImmagine } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<TipologiaImmagine>()

export function TableTipologieImmagini({
  tipologieImmagini,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  tipologieImmagini: TipologiaImmagine[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!tipologieImmagini) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [tipologieImmagini, count])
  
  return (
    <Table
      data={tipologieImmagini}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(tipologia) => (
          <Link to={`/tipologie-immagini/tipologie-immagini/${tipologia.id}`}>
            <LinkMagik className="text-dark">{tipologia.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} tipologie immagini
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>

    </Table>
  )
}
